import { render, staticRenderFns } from "./splitImageItem.vue?vue&type=template&id=ac8898ba"
import script from "./splitImageItem.vue?vue&type=script&lang=js"
export * from "./splitImageItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports